import AddCircleIcon from '@material-ui/icons/AddCircle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';

class PrimaryAddButton extends React.Component {

  render() {

    return (
      <PrimaryButton {...this.props} endIcon={<AddCircleIcon />}>Add</PrimaryButton>
    );
  }
}

PrimaryAddButton.defaultProps = {
  disabled: false
};

PrimaryAddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  classes: PropTypes.object
};

export default withStyles(styles)(PrimaryAddButton);